import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './variantButtonList.scss';
import TabNavigationHelper from '../../../../helpers/tabNavigationHelper';
import { IVariantStore, VariantType } from '../../../../types';
import VariantButton from './variantButton/variantButton';
import { IBrickItem } from '../../../../stores/types';

type Props = {
    variantStore?: IVariantStore,
    brickItem: IBrickItem,
}

@inject('variantStore')
@observer
export default class VariantButtonList extends React.Component<Props> {
    private tabNavigation: TabNavigationHelper;

    constructor(props: Props) {
        super(props);
        this.tabNavigation = TabNavigationHelper.instance;
    }

    get variantContainerClassNames(): string {
        const classes = this.props.variantStore?.isStickyHeader ?
            [styles.variants_container, styles.isStickyHeader] : [styles.variants_container];
        return classes.join(' ');
    };

    get colorButton() {
        if (this.props.brickItem.variantSelection.availableColors[0]?.code === 0) {
            return <></>;
        }

        return (
            <div className={styles.variants_container_item}>
                <VariantButton
                    variantType={VariantType.Color}
                    isMobileHeader={false}
                    isDeactive={!this.props.brickItem.variantSelection.showColorSwitcher}
                    isStickyHeader={this.props.variantStore?.isStickyHeader}
                    brickItem={this.props.brickItem}
                />
            </div>
        );
    }

    get modelButton() {
        const showModelSwitcher = this.props.brickItem.variantSelection.showModelSwitcher;
        const availableModels = this.props.brickItem.variantSelection.availableModels;

        if (showModelSwitcher || (availableModels?.length && availableModels[0]?.code !== 0)) {
            return (
                <div className={styles.variants_container_item}>
                    <VariantButton
                        variantType={VariantType.Model}
                        isMobileHeader={false}
                        isDeactive={!showModelSwitcher}
                        isStickyHeader={this.props.variantStore?.isStickyHeader}
                        brickItem={this.props.brickItem}
                    />
                </div>
            );
        }

        return <></>;
    };

    render() {
        return (
            <div data-testid='variant_button_list_container'
              data-semantic-id='variant_button_list_container' className={this.variantContainerClassNames}
                ref={(el) => this.tabNavigation.setGroupAtt(el)}>
                {this.colorButton}
                {this.props.brickItem.variantSelection.showSizeSwitcher
                    && !this.props.brickItem.variantSelection.isScrew && (
                        <div className={styles.variants_container_item}>
                            <VariantButton
                                variantType={VariantType.Size}
                                isMobileHeader={false}
                                brickItem={this.props.brickItem}
                            />
                        </div>
                    )}
                {this.props.brickItem.variantSelection.showSizeSwitcher
                    && this.props.brickItem.variantSelection.isScrew && (
                        <div className={styles.variants_container_item}>
                            <VariantButton
                                variantType={VariantType.Special}
                                isMobileHeader={false}
                                brickItem={this.props.brickItem}
                            />
                        </div>
                    )}
                {this.modelButton}
            </div>
        );
    }
}

